import { Slider, Typography } from "antd";
import styled from "styled-components";
import color from "../../../../../../theme/color";

const SliderSteps = styled(Slider)<{ error?: boolean }>`
  pointer-events: none;

  &.ant-slider-with-marks {
    /* mark 두줄 */
    margin-bottom: 60px;
  }

  & .ant-slider-rail,
  & .ant-slider-track {
    height: 8px;
  }
  & .ant-slider-track {
    background: ${({ error, theme }) =>
      error ? theme.color.red5 : theme.color.primary7};
  }

  & .ant-slider-step {
    height: 8px;
    & .ant-slider-dot {
      border: none;
      top: 0;
      background-color: ${({ theme }) => theme.color.gray6};
      &.ant-slider-dot-active {
        border: none;
        background-color: ${({ error, theme }) =>
          error ? theme.color.red3 : theme.color.primary3};
      }
    }
  }
  & .ant-slider-handle {
    visibility: hidden;
  }

  & .ant-slider-mark {
    top: 20px;
  }
`;

/**
 * 스텝 라벨 폼
 */
const StepLabel = styled(Typography.Text)<{ color?: string }>`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: ${({ color: fixColor }) => fixColor || color.gray5};
`;
/**
 * 스텝 설명 폼
 */
const StepDescription = styled(Typography.Text)`
  display: inline-block;
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  color: ${color.gray5};
  white-space: pre-wrap;
  /* letter-spacing: -0.5px; */
`;

/**
 * 말풍선
 */
const PopoverContainer = styled.div<{ left?: number }>`
  z-index: 0;
  &::before,
  &&::after {
    content: "";
    visibility: ${({ left }) => (left ? "visible" : "hidden")};
    width: 12px;
    height: 12px;
    position: absolute;
    left: 0;
    top: 0px;
    transform: translate(${({ left }) => (left ? `${left}px` : 0)}, -6px)
      rotate(45deg);
    z-index: 1;
  }
  &::before {
    background: ${({ theme }) => theme.color.gray12};
    border: 1px solid #f0f0f0;
    border-bottom-color: transparent;
    border-right-color: transparent;
  }
`;

export { PopoverContainer, SliderSteps, StepDescription, StepLabel };
